import ApiService from "../../../../services/ApiService";

export const fetchUserProjects = (userId: number, setProjects: Function, setLoading: Function) => {
  setLoading(true);
  ApiService.get(`users/${userId}/projects`)
    .then((response) => setProjects(response.data.projects))
    .catch((error) => console.error("An error occurred while fetching user's projects", error))
    .finally(() => setLoading(false));
};
